module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/docx-1f8f1.png";